import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { ApplicationsService } from 'src/app/applications/applications.service';
import { RunScriptModalService } from './run-script-modal.service';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/list';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { ScrollbarModule } from '@michelin/theme';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'mic-app-run-script-modal',
  templateUrl: './run-script-modal.component.html',
  styleUrls: ['./run-script-modal.component.scss'],
  imports: [MatDialogTitle, MatIcon, MatDivider, ReactiveFormsModule, MatFormField, MatLabel, MatInput, ScrollbarModule, MatButton]
})
export class RunScriptModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<RunScriptModalComponent>>(MatDialogRef);
  private readonly scriptService = inject(RunScriptModalService);
  private readonly applicationsService = inject(ApplicationsService);

  runScript: FormGroup;

  ngOnInit(): void {
    this.runScript = new FormGroup({
      name: new FormControl(null, Validators.required),
      description: new FormControl(null, Validators.required),
      path: new FormControl(null, Validators.required),
      fileName: new FormControl(null, Validators.required)
    });
  }

  onSubmit(): void {
    this.scriptService.addScript(this.applicationsService.myObject.id, this.runScript.value).subscribe(() => {
      this.onNoClick();
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onClose(alert: boolean) {
    this.dialogRef.close(alert);
  }
}
